import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-container" }
const _hoisted_2 = { class: "row mb-5" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, " Roster Notifications ", -1)
const _hoisted_5 = { class: "col col-sm-10 col-md-10 col-lg-8 col-xl-8 mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, " Please select how do you want your employees to receive roster change notifications. ", -1)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 0,
  class: "d-inline-block mt-2"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "small pb-3 text-muted" }, " N.B: Please note that, if you choose sms option, it will only go out successfully if the employees have their correct mobile numbers set in their profile. ", -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_15 = { class: "spinner-border spinner-border-sm ml-1" }
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = { class: "row my-5" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, " Leaves Quota ", -1)
const _hoisted_20 = { class: "col col-sm-10 col-md-10 col-lg-8 col-xl-8 mt-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "pb-3" }, "Please set the leave quota for the employees.", -1)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Leaves Quota", -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_28 = { class: "spinner-border spinner-border-sm ml-1" }
const _hoisted_29 = { class: "row my-5" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "h4 text-primary" }, " Change Password ", -1)
const _hoisted_32 = { class: "col col-sm-10 col-md-10 col-lg-8 col-xl-8 mt-4" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Current Password", -1)
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "New Password", -1)
const _hoisted_37 = {
  key: 0,
  class: "pt-1"
}
const _hoisted_38 = { class: "form-group" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Confirm Password", -1)
const _hoisted_40 = { class: "form-check d-flex align-items-center px-1 mt-2 ml-0" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  class: "my-0 cursor-pointer text-muted",
  for: "defaultCheck1"
}, " Show Password ", -1)
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-xs-12 col-sm-6 col-lg-4 col-xl-3 col-md-5 form-group" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_47 = { class: "spinner-border spinner-border-sm ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ConfirmationModal = _resolveComponent("ConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { crumbs: _ctx.crumbs }, null, 8, ["crumbs"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.roles == 'Org Admin' || _ctx.roles == 'Manager' || _ctx.roles == 'Admin')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_page_title, { margin: "m-0" }, {
                  title: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Form, { onSubmit: _ctx.saveRosterSetting }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("label", {
                          class: _normalizeClass(`btn mr-2 ${
                    _ctx.rosterSetting === 'RosterEmail'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  }`)
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            hidden: "",
                            value: 'RosterEmail',
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rosterSetting) = $event)),
                            name: "RosterSettings",
                            autocomplete: "off"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.rosterSetting]
                          ]),
                          _createTextVNode(" Email ")
                        ], 2),
                        _createElementVNode("label", {
                          class: _normalizeClass(`btn ${
                    _ctx.rosterSetting === 'RosterSMS'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  }`)
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            hidden: "",
                            value: 'RosterSMS',
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rosterSetting) = $event)),
                            name: "RosterSettings",
                            autocomplete: "off"
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.rosterSetting]
                          ]),
                          _createTextVNode(" SMS ")
                        ], 2)
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("label", {
                              class: _normalizeClass(`cursor-pointer rounded-sm m-0 px-2 py-1 border ${
                    _ctx.rosterSetting ? 'border-primary' : ''
                  }`),
                              for: "flexCheckDefault"
                            }, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "mr-1",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rosterSetting) = $event)),
                                id: "flexCheckDefault"
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.rosterSetting]
                              ]),
                              _createTextVNode(" SMS ")
                            ], 2)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          class: "btn-primary btn-lg-cus",
                          isPrimary: true,
                          disabled: _ctx.settingLoading
                        }, [
                          _hoisted_14,
                          _withDirectives(_createElementVNode("span", _hoisted_15, null, 512), [
                            [_vShow, _ctx.settingLoading]
                          ])
                        ], 8, _hoisted_13)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      (_ctx.settingMessage)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            innerHTML: _ctx.settingMessage,
                            class: "alert alert-danger small"
                          }, null, 8, _hoisted_16))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_page_title, { margin: "m-0" }, {
                  title: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Form, {
                  onSubmit: _ctx.saveLeaveQuota,
                  "validation-schema": _ctx.schema3
                }, {
                  default: _withCtx((meta) => [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_input_field, { icon: "hashtag" }, {
                        input: _withCtx(() => [
                          _createVNode(_component_Field, {
                            type: "number",
                            min: "0",
                            max: "99",
                            name: "leavesQuota",
                            placeholder: "Leaves Quota",
                            value: "leavesQuotaModel.value",
                            modelValue: _ctx.leavesQuota,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.leavesQuota) = $event)),
                            class: _normalizeClass(meta.errors.leavesQuota ? 'is-invalid' : '')
                          }, null, 8, ["modelValue", "class"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "leavesQuota",
                            class: "invalid-feedback"
                          })
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("button", {
                          class: "btn-primary btn-lg-cus",
                          disabled: _ctx.quotaLoading
                        }, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("span", _hoisted_28, null, 512), [
                            [_vShow, _ctx.quotaLoading]
                          ])
                        ], 8, _hoisted_26)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_page_title, { margin: "m-0" }, {
            title: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.changePassword,
            "validation-schema": _ctx.schema2,
            ref: "form"
          }, {
            default: _withCtx((meta) => [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createVNode(_component_input_field, { icon: "key" }, {
                  input: _withCtx(() => [
                    _createVNode(_component_Field, {
                      type: `${_ctx.showPassword ? 'text' : 'password'}`,
                      name: "currentPassword",
                      placeholder: "Current Password",
                      class: _normalizeClass(meta.errors.currentPassword ? 'is-invalid' : '')
                    }, null, 8, ["type", "class"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "currentPassword",
                      class: "invalid-feedback"
                    })
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_input_field, { icon: "key" }, {
                  input: _withCtx(() => [
                    _createVNode(_component_Field, {
                      type: `${_ctx.showPassword ? 'text' : 'password'}`,
                      name: "newPassword",
                      placeholder: "Password",
                      onInput: _ctx.checkPassword,
                      modelValue: _ctx.newPassword,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newPassword) = $event)),
                      class: _normalizeClass(meta.errors.newPassword ? 'is-invalid' : '')
                    }, null, 8, ["type", "onInput", "modelValue", "class"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "newPassword",
                      class: "invalid-feedback"
                    }),
                    (_ctx.newPassword)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_37, [
                          _createElementVNode("span", {
                            class: _normalizeClass(`d-block ${
                      _ctx.contains_eight_characters ? 'text-success' : 'text-muted'
                    }`)
                          }, [
                            _createTextVNode(" - Minimum 8 characters "),
                            (_ctx.contains_eight_characters)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  class: "ml-1 text-success",
                                  icon: "check-circle"
                                }))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(`d-block ${
                      _ctx.contains_number ? 'text-success' : 'text-muted'
                    }`)
                          }, [
                            _createTextVNode(" - Contains number "),
                            (_ctx.contains_number)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  class: "ml-1 text-success",
                                  icon: "check-circle"
                                }))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(`d-block ${
                      _ctx.contains_uppercase ? 'text-success' : 'text-muted'
                    }`)
                          }, [
                            _createTextVNode(" - Contains uppercase "),
                            (_ctx.contains_uppercase)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  class: "ml-1 text-success",
                                  icon: "check-circle"
                                }))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(`d-block ${
                      _ctx.contains_lowercase ? 'text-success' : 'text-muted'
                    }`)
                          }, [
                            _createTextVNode(" - Contains lowercase "),
                            (_ctx.contains_lowercase)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  class: "ml-1 text-success",
                                  icon: "check-circle"
                                }))
                              : _createCommentVNode("", true)
                          ], 2),
                          _createElementVNode("span", {
                            class: _normalizeClass(`d-block ${
                      _ctx.contains_special_character ? 'text-success' : 'text-muted'
                    }`)
                          }, [
                            _createTextVNode(" - Contains special character "),
                            (_ctx.contains_special_character)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  class: "ml-1 text-success",
                                  icon: "check-circle"
                                }))
                              : _createCommentVNode("", true)
                          ], 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createVNode(_component_input_field, { icon: "key" }, {
                  input: _withCtx(() => [
                    _createVNode(_component_Field, {
                      type: `${_ctx.showPassword ? 'text' : 'password'}`,
                      name: "confirmPassword",
                      placeholder: "Confirm Password",
                      class: _normalizeClass(meta.errors.confirmPassword ? 'is-invalid' : '')
                    }, null, 8, ["type", "class"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "confirmPassword",
                      class: "invalid-feedback"
                    })
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_40, [
                  _withDirectives(_createElementVNode("input", {
                    class: "cus-checkbox m-0 mr-2",
                    type: "checkbox",
                    value: "true",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showPassword) = $event)),
                    id: "defaultCheck1"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.showPassword]
                  ]),
                  _hoisted_41
                ])
              ]),
              _createElementVNode("div", null, [
                (_ctx.passwordMessage)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.passwordMessage,
                      class: "alert alert-danger small"
                    }, null, 8, _hoisted_42))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("button", {
                    class: "btn-primary btn-lg-cus",
                    isPrimary: true,
                    disabled: _ctx.passwordLoading
                  }, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("span", _hoisted_47, null, 512), [
                      [_vShow, _ctx.passwordLoading]
                    ])
                  ], 8, _hoisted_45)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _createVNode(_component_ConfirmationModal, { ref: "confirmDialogue" }, null, 512)
  ], 64))
}